<template>
  <div class="photo-page" :style="this.provide ? {background: '#F2F8FE'}: {}">
    <p class="photo-page-desc">请上传提现人的有效二代身份证:</p>
    <auth-upload class="photo-page-upload" @sendOut="receive" />
    <auth-upload class="photo-page-upload" :type="2" @sendOut="receive" />
    <div class="photo-page-demo">
      <p>拍摄示例</p>
      <img src="../../assets/images/authentication/auth-demo.png" alt="">
      <long-btn text="下一步" :canUse="isComplete" @confirm="complete" :blue="isComplete && provide"/>
    </div>
  </div>
</template>

<script>
import AuthUpload from './AuthUpload'
import LongBtn from './LongBtn'
export default {
  name: 'PhotoPage',
  data () {
    return {
      posiImg: '',
      negaImg: '',
    }
  },
  props: {
    // 按钮文字信息
    text: {
      type: String,
      default: '确认',
    },
  },
  computed: {
    isComplete () {
      return !!this.posiImg && !!this.negaImg
    },
    provide () {
      return this.$route.query.provide === 'ciba'
    }
  },
  components: {
    AuthUpload,
    LongBtn,
  },
  methods: {
    receive(res, type) {
      type === 1 ? this.posiImg = res : this.negaImg = res
      console.log(this.posiImg)
      console.log(this.negaImg)
      console.log(res, type)
    },
    complete() {
      this.$emit('submit', {
        imageFront: this.posiImg,
        imageBack: this.negaImg,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .photo-page {
    width: 100%;
    min-height: 100vh;
    background-color: #FFF8EF;
    text-align: center;
    padding: use(43) 0 use(36);

    &-desc {
      font-size: use(24);
      color: #A88667;
      margin-bottom: use(22);
    }

    &-upload {
      margin-bottom: use(22);
    }

    &-demo {
      width: use(696);
      margin: use(38) auto 0;
      background: #FFFFFF;
      box-shadow: 0 use(6) use(10) 0 rgba(0, 0, 0, 0.05);
      border-radius: use(10);
      padding: use(26) 0 use(39);

      p {
        font-size: use(30);
        color: #4A4A4A;
        margin-bottom: use(20);
      }

      img {
        width: 90%;
        margin-bottom: use(30);
      }
    }
  }
</style>
